import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    CmsConfig,
    I18nModule, provideConfig,
    provideDefaultConfig,
    UrlModule,
} from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { UigMiniCartComponent } from './uig-mini-cart.component';

@NgModule({
    imports: [CommonModule, RouterModule, UrlModule, IconModule, I18nModule],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                MiniCartComponent: {
                    component: UigMiniCartComponent,
                },
            },
        }),
    ],
    declarations: [UigMiniCartComponent],
    exports: [UigMiniCartComponent]
})
export class UigMiniCartModule { }
